import { EstadosSolicitud } from '../enumeraciones/estados-solicitud.enum';
import { TipoRnt } from '../enumeraciones/tipo-rnt.enum';
import { TipoSolicitud } from '../enumeraciones/tipo-solicitud.enum';
import { ResponseServiceModel } from './response-service.model';

export class DatoSolicitudSharedModel {
	data: any;
	tipo_solicitud: TipoSolicitud;
	estado_solicitud: EstadosSolicitud;
  capacidadesTecnicas: ResponseServiceModel;
  capacidadesOperativas: ResponseServiceModel;
	tipo_rnt: TipoRnt;
	categoria_id?: number;
  config_capacidad_tecnica: boolean;
  config_capacidad_operativa: boolean;
}
